import { matterPaths } from '@/routing/paths'

export type WritingSampleViewerContext = {
  matterId?: string | null
}

export function buildWritingSampleStandaloneViewerURL(referenceId: string | null | undefined, context?: WritingSampleViewerContext): string | null {
  const cleanedReferenceId = typeof referenceId === 'string' && referenceId.trim().length > 0 ? referenceId.trim() : null
  const matterId = typeof context?.matterId === 'string' && context.matterId.trim().length > 0 ? context.matterId.trim() : null

  if (!cleanedReferenceId || !matterId) return null

  return matterPaths.referenceViewer.writingSample(matterId, encodeURIComponent(cleanedReferenceId))
}
